/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum StatementOptions {
  merchantTagLine = "MERCHANTTAGLINE",
  merchantLogoFileName = "STMTLOGOFNAME",
  payByPhoneNo = "PAYBYPHONENO",
  payByPhoneHours = "PAYBYPHONEHOURS",
  payQueryPhoneNumber = "BILLQUERYPHONENO",
  billQueryHours = "BILLQUERYHOURS",
  statementDueDateLeadDays = "STMTDUEDATELEADDAYS",
  statementTestMode = "STMTTESTMODE",
  displayAgingBoxes = "DISPLAYGUARAGEBRACKETS",
  displayInsuranceAgingBoxes = "DISPLAYINSAGEBRACKETS",
  displayDetachReturnMail = "DISPLAYDETACHRETURNBYMAIL",
  displayDetails = "DISPLAYSTMTDETAIL",
  displayMerchantName = "DISPLAYMERCHANTNAME",
  payByCheck = "PAYBYCHECKOK",
  payByMoneyOrder = "PAYBYMONEYORDEROK"
}
